//
//
//
//
//
//
//
//

export default {
  components: {},
  data () {
    return {
      user: {
        userId: ''
      },
      info: {
        id: '',
        title: '',
        author: '',
        time: '',
        imgList: [],
        fcontent: '',
        scontent: '',
        url: ''
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.user = vm.$store.state.sx.user || vm.user
      vm.$post('article/detail', {
        id: to.params.id,
        type: '500',
        userId: vm.user.userId
      }, (res) => {
        if (res.code === 200) {
          for (let item in res.data) {
            if (res.data[item] !== undefined && res.data[item] !== null) {
              vm.info[item] = res.data[item]
            }
          }
        }
      })
    })
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/page/FAQView.vue